<div
  #trigger="cdkOverlayOrigin"
  class="container"
  cdkOverlayOrigin
  (mouseenter)="displayOverlay()"
  (mouseleave)="hideOverlay()">
  @if (triggerComponent) {
    <ng-template [ngTemplateOutlet]="triggerComponent"></ng-template>
  } @else {
    <mat-icon [ngStyle]="{ width: iconSize(), height: iconSize(), fontSize: iconSize() }">
      {{ icon() ?? 'info_outlined' }}
    </mat-icon>
  }
  <ng-template
    cdk-connected-overlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isVisible">
    <div class="mdc-tooltip mdc-tooltip--shown">
      <div class="tooltip-content">
        <ng-content></ng-content>
      </div>
    </div>
  </ng-template>
</div>
